<div id="breadcrumb">
    <div class="container">
        <div class="breadcrumb-wrapper">
            <h1>Portfolio</h1>
            <ul>
                <li><a href="#">Home</a></li>
                <li><i class="bi bi-chevron-double-right"></i></li>
                <li><a href="#">Portfolio</a></li>
            </ul>
        </div>
    </div>
</div>


<div id="case-studies" class="page">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 order-lg-1 order-md-1">
                <div class="item one">
                    <img src="assets/images/case01.jpg" alt="">
                    <div class="action">
                        <span>commercial</span>
                        <h4>We are digital agency</h4>
                        <a href="#"><i class="bi bi-arrow-right"></i></a>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 order-lg-2 order-md-2 mt-sm-30">
                <div class="item two">
                    <img src="assets/images/case02.jpg" alt="">
                    <div class="action">
                        <span>commercial</span>
                        <h4>We are digital agency</h4>
                        <a href="#"><i class="bi bi-arrow-right"></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 order-lg-3 order-md-3 mt-md-30 mt-sm-30">
                <div class="item three">
                    <img src="assets/images/case03.jpg" alt="">
                    <div class="action">
                        <span>commercial</span>
                        <h4>We are digital agency</h4>
                        <a href="#"><i class="bi bi-arrow-right"></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-8 col-md-12 order-lg-4 order-md-5">
                <div class="item four">
                    <img src="assets/images/case04.jpg" alt="">
                    <div class="action">
                        <span>commercial</span>
                        <h4>We are digital agency</h4>
                        <a href="#"><i class="bi bi-arrow-right"></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 order-lg-5 order-md-4">
                <div class="item five">
                    <img src="assets/images/case05.jpg" alt="">
                    <div class="action">
                        <span>commercial</span>
                        <h4>We are digital agency</h4>
                        <a href="#"><i class="bi bi-arrow-right"></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 order-lg-6 order-md-6">
                <div class="item six">
                    <img src="assets/images/case06.jpg" alt="">
                    <div class="action">
                        <span>commercial</span>
                        <h4>We are digital agency</h4>
                        <a href="#"><i class="bi bi-arrow-right"></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 order-lg-7 order-md-7">
                <div class="item six">
                    <img src="assets/images/case07.jpg" alt="">
                    <div class="action">
                        <span>commercial</span>
                        <h4>We are digital agency</h4>
                        <a href="#"><i class="bi bi-arrow-right"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="pagination-area">
            <ul>
                <li><a href="#"><i class="bi bi-arrow-left"></i></a></li>
                <li><a href="#">1</a></li>
                <li><a href="#">2</a></li>
                <li><a href="#" class="active">3</a></li>
                <li><a href="#">4</a></li>
                <li><a href="#"><i class="bi bi-arrow-right"></i></a></li>
            </ul>
        </div>
    </div>
</div><!-- #case-studies -->

<footer id="footer">
    <div class="container">
        <div class="row">

            <!-- About Section -->
            <div class="col-md-6 col-lg-3">
                <div class="about">
                    <img class="logo" src="assets/icons/Transparent-2.png" alt="iTech Logo">
                    <p>
                        iTech is a leading IT solutions and consultancy provider, helping businesses
                        innovate, streamline operations, and achieve sustainable growth. From
                        software development to cloud transformation, we deliver secure, scalable,
                        and tailored solutions to meet your unique business needs.
                    </p>
                    <div class="social-icon">
                        <a href="#"><i class="bi bi-facebook"></i></a>
                        <a href="#"><i class="bi bi-twitter"></i></a>
                        <a href="#"><i class="bi bi-instagram"></i></a>
                    </div>
                </div>
            </div>

            <!-- Quick Links -->
            <div class="col-md-6 col-lg-3">
                <div class="quick-link">
                    <h4>Quick Links</h4>
                    <ul>
                        <li><a href="#">Product Design</a></li>
                        <li><a href="#">Application Development</a></li>
                        <li><a href="#">Cyber Security</a></li>
                        <li><a href="#">Data Quality Management</a></li>
                        <li><a href="#">IT Consultancy</a></li>
                        <li><a href="#">Mobile Development</a></li>
                        <li><a href="#">Cloud Migration</a></li>
                    </ul>
                </div>
            </div>

            <!-- Address -->
            <div class="col-md-6 col-lg-3">
                <div class="address">
                    <h4>Our Address</h4>
                    <img src="assets/images/img-footer-map.png" alt="Map">
                    <p>
                        <i class="bi bi-geo-alt-fill"></i>
                        <span>91 Western Road, Brighton, England</span>
                    </p>
                </div>
            </div>

            <!-- Contact Info -->
            <div class="col-md-6 col-lg-3">
                <div class="contact">
                    <h4>Contact Us</h4>

                    <div class="phone">
                        <p>
                            <i class="bi bi-telephone-fill"></i>
                            <a href="tel:+441632960896">+44 1632 960896</a>
                        </p>
                    </div>

                    <div class="email">
                        <p>
                            <i class="bi bi-envelope-fill"></i>
                            <a href="mailto:info@itech.com">info@itech.com</a>
                        </p>
                    </div>

                    <div class="subscribe">
                        <p>Subscribe to our Newsletter</p>
                        <form action="#">
                            <input type="email" placeholder="Your email" required>
                            <button type="submit"><i class="bi bi-arrow-right"></i></button>
                        </form>
                    </div>
                </div>
            </div>

        </div>

        <!-- Copyright -->
        <div class="copyright">
            <div class="left">
                <p>Copyright © 2025 iTech. All rights reserved.</p>
            </div>
            <div class="copyright-menu">
                <ul>
                    <li><a href="#">Terms & Condition</a></li>
                    <li><a href="#">Privacy Policy</a></li>
                    <li><a href="#">Contact Us</a></li>
                </ul>
            </div>
        </div>

    </div>
</footer>
